var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chatbots-template"},[_c('SectionChatbots')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }